import { render, staticRenderFns } from "./EntityNameColumnTemplateComponent.vue?vue&type=template&id=59779f31"
import script from "./EntityNameColumnTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./EntityNameColumnTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59779f31')) {
      api.createRecord('59779f31', component.options)
    } else {
      api.reload('59779f31', component.options)
    }
    module.hot.accept("./EntityNameColumnTemplateComponent.vue?vue&type=template&id=59779f31", function () {
      api.rerender('59779f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/EntityNameColumnTemplateComponent.vue"
export default component.exports